import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingService } from '../../../core/services/loading/loading.service';
import { ApplicationFooterComponent } from '../../components/fcc-601/footer/application-footer.component';
import { ApplicationHeaderComponent } from '../../components/fcc-601/header/application-header/application-header.component';
import { ApplicationNavigationBarComponent } from '../../components/fcc-601/navigation-bar/application-navigation-bar.component';
import { ApplicationNavigationStepsComponent } from '../../components/fcc-601/navigation-steps/application-navigation-steps.component';
import { LoadingComponent } from '../../components/loading/loading.component';
import { MasqueradeHeaderComponent } from '../../components/masquerade-header/masquerade-header.component';
import { SidenavComponent } from '../../components/sidenav/sidenav.component';

@Component({
    selector: 'app-application-preparation-layout',
    templateUrl: './application-preparation-layout.component.html',
    styleUrls: ['./application-preparation-layout.component.scss'],
    imports: [
        RouterModule,
        SidenavComponent,
        ApplicationHeaderComponent,
        ApplicationNavigationStepsComponent,
        ApplicationNavigationBarComponent,
        ApplicationFooterComponent,
        MasqueradeHeaderComponent,
        AsyncPipe,
        LoadingComponent,
    ],
})
export class ApplicationPreparationLayoutComponent {
    private readonly loadingService = inject(LoadingService);
    loading$ = this.loadingService.loading$;
}
